




































import Vue from "vue";
import { PropType } from "vue";
import Layout from "@/components/Pages/Password/Atoms/Layout/index.vue";
import Body from "@/components/Atoms/Typography/Body/index.vue";
import TextField from "@/components/Atoms/Forms/TextField/index.vue";
import Button from "@/components/Atoms/Button/index.vue";
import { Data, Methods, Computed, Props } from "./types";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "PasswordReissue",
  components: {
    Layout,
    Body,
    TextField,
    Button
  },
  props: {
    isLoading: {
      type: Boolean,
      required: true
    },
    errors: {
      type: Array as PropType<Props["errors"]>,
      required: true
    }
  },
  computed: {
    disabled() {
      return !this.auth.email;
    },
    auth() {
      return this.$store.state.domains.user.passwordReissue;
    }
  },
  methods: {
    submit() {
      this.$emit("submit");
    }
  }
});
